export const projects = [
  {
    id: 6,
    title: "🎮 Videogames Store – Java Edition",
    shortDescription: "E-commerce de videojuegos migrado 100% a Java + Spring Boot + MongoDB. Autenticación JWT, carrito persistente, dashboard admin, órdenes y simulación de pagos. Proyecto personal post-Digitalers/Talento Tech.",
    description: `Migración completa de mi tienda de videojuegos original (Node.js) a stack empresarial Java. 
Proyecto personal posterior a Digitalers y Talento Tech para aplicar y consolidar conocimientos de backend Java en un caso real complejo y profesional.

Funcionalidades implementadas:
• Backend completo con Spring Boot 3 + Spring Security + JWT + roles (ADMIN / USER)
• Persistencia con Spring Data MongoDB + repositorios personalizados y consultas avanzadas
• CRUD completo de videojuegos, categorías, usuarios, carrito y órdenes
• Carrito persistente en base de datos y flujo de compra con estados
• Dashboard admin con estadísticas en tiempo real y gestión total
• Autenticación segura, protegida contra ataques comunes
• Testing unitario e integración con JUnit 5 + Mockito
• Arquitectura por capas limpia, excepciones globales, validaciones robustas y respuestas estandarizadas
• Frontend React moderno con diseño gaming completo

Tecnologías principales: Java 17 • Spring Boot 3 • Spring Security • JWT • Spring Data MongoDB • React • Redux Toolkit • CSS Modules`,
    achievements: [
      "Migración exitosa de Node.js → Spring Boot + MongoDB aplicando patrones empresariales",
      "Implementación de autenticación JWT segura con roles y refresh token",
      "Dashboard administrativo completo con filtros, búsquedas y estadísticas",
      "Carrito y órdenes persistentes con lógica de negocio robusta",
      "Testing completo (JUnit 5 + Mockito)",
      "Código 100% mantenible, escalable y listo para producción"
    ],
    img: "/images/videogames/image1.webp", 
    images: ["/images/videogames/image1.webp", "/images/videogames/image3.webp", "/images/videogames/image4.webp","/images/videogames/image6.webp", "/images/videogames/image2.webp","/images/videogames/image5.webp"],
    github: "https://github.com/bamioezequiel/videogames-java",
    video: "https://youtu.be/38Fpr70uQGM",
    demo: "https://videogames-java.vercel.app/",
    languages: ["Java", "Spring Boot", "Spring Security", "JWT", "MongoDB", "React", "Redux Toolkit"],
    dateDay: "19",
    dateMonth: "NOVIEMBRE",
    dateYear: "2025",
  },
  {
    id: 4,
    title: "🛍️ EasyStoreApp – Certificado Talento Tech + Digitalers",
    shortDescription: "E-commerce fullstack Java + Spring Boot + MySQL. Proyecto final certificado por Ministerio de Educación (Talento Tech) y Digitalers (Telecom/Educación IT). JWT, roles, carrito, órdenes y Swagger.",
    description: `Proyecto final certificado de los programas Talento Tech (Gobierno CABA) y Digitalers (Telecom + Educación IT) – Noviembre 2025.

API REST completa desarrollada desde cero con arquitectura limpia y patrones empresariales reales:

• Spring Boot 3 + Spring Security + JWT + roles (ADMIN / USER)
• Spring Data JPA + Hibernate + MySQL
• Gestión completa de productos, categorías, usuarios, carrito de compras y órdenes
• Validaciones robustas, excepciones globales y respuestas estandarizadas
• Testing unitario e integración con JUnit 5 + Mockito
• Documentación interactiva con Swagger UI
• Frontend React + Redux Toolkit + diseño responsive y moderno

Evaluado y aprobado oficialmente → certificado emitido noviembre 2025.`,
    achievements: [
      "Certificado oficial del Ministerio de Educación + Digitalers (Telecom/Educación IT)",
      "Arquitectura limpia por capas + código 100% mantenible",
      "Testing completo con JUnit 5 + Mockito",
      "Documentación profesional con Swagger UI",
      "Implementación robusta de carrito y órdenes con lógica de negocio real"
    ],
    img: "/images/easystore.webp", 
    images: [],
    github: "https://github.com/bamioezequiel/EasyStoreApp-TechLab",
    video: "https://youtu.be/ZBT0lrTEd5g",
    demo: "https://techlab-bamioezequiel.vercel.app/",
    languages: ["Java", "Spring Boot", "Spring Security", "JWT", "MySQL", "React", "Redux Toolkit", "Swagger"],
    dateDay: "15",
    dateMonth: "NOVIEMBRE",
    dateYear: "2025",
  },
  {
    id: 1,
    title: "🎮 Videogames Store (v1 – Node.js)",
    shortDescription: "Mi primer e-commerce fullstack individual post-Henry. Base del proyecto que luego migré a Java + Spring Boot en 2025.",
    description: "Primer e-commerce individual después del bootcamp Henry (2023). Implementado con MERN stack + TypeScript + integración real de Mercado Pago. Sirvió como base para la versión Java actual.",
    achievements: [
      "Desarrollo fullstack 100% individual",
      "Integración real de Mercado Pago con webhooks",
      "Uso avanzado de TypeScript y MongoDB por iniciativa propia"
    ],
    img: "/images/videogamesjs.webp", 
    images: [],
    github: "https://github.com/bamioezequiel/project-videogames",
    video: "",
    languages: ["JavaScript", "TypeScript", "React", "MongoDB", "Mercado Pago"],
    dateDay: "23",
    dateMonth: "FEBRERO",
    dateYear: "2023",
  },
  {
    id: 3,
    title: "✈️ HenryTravel – Proyecto Grupal Henry",
    shortDescription: "Plataforma turística fullstack en equipo de 8 personas con metodología Scrum. Stripe + Mercado Pago + Auth0 + panel admin.",
    description: "Proyecto final del bootcamp Henry (2022). Equipo de 8 developers usando Scrum real (dailies + Trello).\nMi rol principal: maquetación completa del frontend + integración de Auth0 + pasarelas de pago Stripe y Mercado Pago Argentina.",
    achievements: [
      "Experiencia real de trabajo en equipo con metodología Scrum",
      "Integración de Stripe y Mercado Pago Argentina",
      "Auth0 + roles (admin, user, guest)",
      "Panel admin completo con reportes"
    ],
    img: "/images/henrytravel.webp", 
    images: [],
    github: "https://github.com/bamioezequiel/proyecto-final-henry",
    demo: "https://proyecto-final-henry.vercel.app/",
    video: "",
    languages: ["React", "Redux", "Node.js", "Express", "PostgreSQL", "Auth0", "Stripe", "Mercado Pago"],
    dateDay: "14",
    dateMonth: "AGOSTO",
    dateYear: "2022",
  },
  {
    id: 2,
    title: "💰 Payments – Práctica Mercado Pago",
    shortDescription: "E-commerce de monedas virtuales enfocado en integración completa de Mercado Pago.",
    description: "Proyecto personal para dominar pasarelas de pago. Implementación completa del flujo de Mercado Pago con preferencias, webhooks, usuarios de prueba y manejo de estados.",
    achievements: ["Integración real de Mercado Pago", "Stack TypeScript + Node.js + React"],
    img: "/images/payments.webp", 
    images: [],
    video: "https://vimeo.com/739430405?share=copy",
    github: "https://typescript-payments-be.vercel.app/",
    languages: ["TypeScript", "Node.js", "React", "Mercado Pago"],
    dateDay: "21",
    dateMonth: "DICIEMBRE",
    dateYear: "2022",
  },
  {
    id: 8,
    title: "🍽️ PI Food – Henry",
    shortDescription: "Primer proyecto fullstack individual en Henry. Consumo de API externa + CRUD propio + filtros combinados.",
    description: "Proyecto integrador individual Henry. SPA de recetas con consumo de Spoonacular API, filtros avanzados, paginación y creación de recetas propias en PostgreSQL.",
    achievements: ["Primer fullstack autónomo", "Defensa exitosa ante instructor", "Filtros combinados complejos"],
    img: "/images/food.webp", 
    images: [],
    github: "https://github.com/bamioezequiel/PI-Food-main",
    demo: "https://pi-food-bamio-ezequiel.vercel.app/",
    video: "https://youtu.be/IZxF_ng8iTU",
    languages: ["React", "Redux", "Node.js", "Express", "PostgreSQL"],
    dateDay: "02",
    dateMonth: "JULIO",
    dateYear: "2022",
  },
];